import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../../components/Icon/Icon'

const SummaryOverview = ({ title, icon, content }) => (
  <div className="summary">
    <header>
      <h3 className="summary__title">
        <Icon name={icon} className="-blue summary__icon" />
        {title}
      </h3>
    </header>
    <div className="summary__body">
      {content && (
        <table>
          <tbody>
            {Object.keys(content).map(
              (key, keyIndex) =>
                !!content[key] && (
                  <tr key={keyIndex}>
                    <td>
                      <h4>{key}</h4>
                    </td>
                    <td>
                      <p>{content[key]}</p>
                    </td>
                  </tr>
                )
            )}
          </tbody>
        </table>
      )}
    </div>
  </div>
)
SummaryOverview.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  content: PropTypes.object,
}
export default SummaryOverview
